import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import usePost from "../../Hooks/usePost";
import Logo from "../../components/Authentication/Logo";
import ButtonSubmit from "../Buttons/ButtonSubmit";

export default function LoginForm({ props }) {
  const navigation = useNavigate();
  const { execute, pending, data } = usePost();
  const [values, setValues] = useState({
    email: "",
  });

  useEffect(() => {
    const savedCredentials = localStorage.getItem("credentials");
    if (savedCredentials && values.email === "" && values.password === "") {
      const credentials = JSON.parse(savedCredentials);
      setValues((prevValues) => ({
        ...prevValues,
        email: credentials.email,
      }));
    } else {
      // If no saved credentials or email/password already provided, ensure rememberMe is set to false
      setValues((prevValues) => ({
        ...prevValues,
        rememberMe: false,
      }));
    }
  }, []);

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const validateEmail = (email) => {
    return email.match(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  };

  const handleForgot = () => {
    const Method = "POST",
      endPoint = "auth/forgotPassword",
      token = null;
    const raw = JSON.stringify({
      email: values.email,
    });
    execute(endPoint, raw, Method, true, token);

    if (values.rememberMe) {
      localStorage.setItem(
        "credentials",
        JSON.stringify({ email: values.email, password: values.password })
      );
    } else {
      localStorage.removeItem("credentials");
    }
  };

  useEffect(() => {
    if (data?.data?.status === "success") {
      navigation("/message");
    }
  }, [data?.data?.status]);

  return (
    <div className="login-form-container">
      <div className="login-form-header">
        <Logo />
        <h1>Forgot Password</h1>
        <p>Please Enter your email</p>
      </div>
      <div className="form-field">
        <label>Email</label>
        <input
          type="email"
          value={values.email}
          onChange={handleChange("email")}
          className={!validateEmail(values.email) ? "" : ""}
          name="email" // Unique name for the email input
        />
        {!validateEmail(values.email) && (
          <p className="mt-1 text-primary">Enter a valid email</p>
        )}
      </div>

      <div className="w-100 mb-2 d-flex justify-content-end">
        <div className="mx-1">Already have an account?</div>
        <Link to="/login">Login</Link>
      </div>
      <div className="d-flex justify-content-center">
        <ButtonSubmit
          Title="Send"
          BackgroundColor="#f68a20"
          ColorText="#fff"
          BorderColor="#f68a20"
          borderRadius={25}
          handleOnclick={handleForgot}
          pending={pending}
        />
      </div>
    </div>
  );
}
